import { useQuery } from "@tanstack/react-query";

import type { TeamRole } from "../api/generated/model";
import { accessScopeQuery, findTeam } from "../api/session";

export interface Membership {
  userId: string;
  role: TeamRole;
}

/** The user's id and role in this team, from the access scope: the one source for gates (F3). */
export function useMembership(teamId: string): Membership | undefined {
  const { data: scope } = useQuery(accessScopeQuery());
  if (scope === undefined) return undefined;
  const team = findTeam(scope, teamId);
  return team === undefined ? undefined : { userId: scope.user_id, role: team.role };
}
